import GenericBundleFeatureTable from '../../../components/feature-table/suite-feature-table/GenericBundleFeatureTable';
import { SCREENS } from '../../constants/tracking/Screens';
import { MARKETING_PLUS_PAGE_FEATURE_TABLE } from '../../constants/tracking/TrackingSources';
import { jsx as _jsx } from "react/jsx-runtime";
export const MarketingPlusFeatureTable = () => {
  const apiNames = ['marketing-plus-professional-bundle', 'marketing-plus-enterprise-bundle'];
  return /*#__PURE__*/_jsx(GenericBundleFeatureTable, {
    apiNames: apiNames,
    screen: SCREENS.MARKETING_PLUS,
    trackingSource: MARKETING_PLUS_PAGE_FEATURE_TABLE
  });
};